import store from '@/store'
import network from '@/utils/network'
import { MODAL_EVENT_UPDATE_AGENTS } from '@/consts/app'
import { $ui } from '@/utils/ui'
import { agencyPath, createRequestWithComputedFilters } from '@/utils/api'

/**
 * Créé / met à jour un agent
 * @returns {Promise<>}
 */
export const postAgencyAgent = async (agent) => {
  const slugAgency = store.getters['user/agencySlug']
  const { data = {} } = await network.post(`agency/${slugAgency}/agent`, agent)
  $ui.$emit(MODAL_EVENT_UPDATE_AGENTS, [data.agent])
  return data
}

/**
 * Supprime un agent
 * @returns {Promise<>}
 */
export const deleteAgencyAgent = async ({ id, slug }) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.delete(`agency/${slugAgency}/agent/${slug}`)
  $ui.$emit(MODAL_EVENT_UPDATE_AGENTS, [{ id, slug, _deleted: true }])
  return r.data
}

export const getAgencyAgentExport = async (params) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.post(`agency/${slugAgency}/fetch/agents/export`, params
  )
  return r.data
}

/**
 * Récupère le badge de l'agent
 * @param slug
 * @return {Promise<>}
 */
export const getBadgeAgent = async ({ slug }) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.get(`agency/${slugAgency}/agent/${slug}/badge`)
  return r.data
}

/**
 * Récupère le pdf de remise de bon d'un agent
 * @param slug
 * @return {Promise<>}
 */
export const getAgencyAgentItemsPdf = async ({ slug }) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.get(`agency/${slugAgency}/agent/${slug}/items/pdf`)
  return r.data
}

/**
 * Récupère les horaires de tout les agents
 */
export const fetchAgentsHours = createRequestWithComputedFilters(
  async (params) => {
    const r = await network.post(`${agencyPath()}/agents/fetch/hours`, params)
    return r.data
  })
